import { Outlet } from 'react-router-dom';
import { NavBar } from './nav-bar';

export function AppShell() {
  return (
    <div className="relative flex min-h-screen flex-col">
      {/* Subtle background ambience */}
      <div
        aria-hidden
        className="pointer-events-none fixed inset-0 -z-10 overflow-hidden"
      >
        <div className="absolute -left-32 -top-32 h-96 w-96 rounded-full bg-primary/10 blur-3xl" />
        <div className="absolute -bottom-32 -right-32 h-96 w-96 rounded-full bg-blue-500/5 blur-3xl" />
      </div>

      <NavBar />

      <main className="container-pc flex-1 py-8">
        <Outlet />
      </main>

      {/* Footer is dev-only: prod build omits the build-stamp strip entirely. */}
      {import.meta.env.DEV && (
        <footer className="border-t border-border/60 bg-card/40 py-3">
          <div className="container-pc flex items-center justify-between text-xs text-muted-foreground">
            <span>PostChecker</span>
            <span>{import.meta.env.VITE_APP_VERSION ?? 'dev'}</span>
          </div>
        </footer>
      )}
    </div>
  );
}
